import { __decorate, __metadata } from "tslib";
import { Expose } from 'class-transformer';
import { IsArray, IsEnum } from 'class-validator';
import { ConfigurationExposeGroup } from '../../interface';
export class ReadDisabledActionsByChannelDto {
}
__decorate([
    IsEnum({ always: true, each: true }),
    Expose({
        groups: [
            ConfigurationExposeGroup.FIXTURE,
            ConfigurationExposeGroup.READ,
            ConfigurationExposeGroup.CREATE,
            ConfigurationExposeGroup.PATCH,
            ConfigurationExposeGroup.DELETE,
        ],
    }),
    __metadata("design:type", Array)
], ReadDisabledActionsByChannelDto.prototype, "mail", void 0);
__decorate([
    IsArray({ always: true }),
    IsEnum({ always: true, each: true }),
    Expose({
        groups: [
            ConfigurationExposeGroup.FIXTURE,
            ConfigurationExposeGroup.READ,
            ConfigurationExposeGroup.CREATE,
            ConfigurationExposeGroup.PATCH,
            ConfigurationExposeGroup.DELETE,
        ],
    }),
    __metadata("design:type", Array)
], ReadDisabledActionsByChannelDto.prototype, "sms", void 0);
__decorate([
    IsEnum({ always: true, each: true }),
    Expose({
        groups: [
            ConfigurationExposeGroup.FIXTURE,
            ConfigurationExposeGroup.READ,
            ConfigurationExposeGroup.CREATE,
            ConfigurationExposeGroup.PATCH,
            ConfigurationExposeGroup.DELETE,
        ],
    }),
    __metadata("design:type", Array)
], ReadDisabledActionsByChannelDto.prototype, "push", void 0);
//# sourceMappingURL=ReadDisabledActionsByChannelDto.js.map